import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NbDateService, NbDialogService, NbWindowRef } from '@nebular/theme';
import { BUCKZY_CONSTANTS } from 'app/models/buckzy-constants/buckzy-constants.model';
import { ClientAccountsInfo } from 'app/models/clients/account/account.model';
import { BuckzyCode } from 'app/models/handle-party/buckzy-code.model';
import { Country } from 'app/models/users/country.model';

import { AccountService } from 'app/services/finance/account.service';
import { HelperService } from 'app/services/helper/helper.service';
import { GeneralService, PartyType } from 'app/services/mto/general/general.service';
import { Observable, ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'window',
  templateUrl: './window.component.html',
  styleUrls: ['./window.component.scss'],
})

export class WindowComponent implements OnInit {

  fileName: any = [];
  file: File;
  acceptedFileType =
    ".pdf, .tiff, .jpeg, .gif, .png, .svg, .jpg, .webp, .avif, .apng, .csv, xlsx";
  fileType: string;
  fileTypes: Observable<BuckzyCode[]>;
  @ViewChild('dragDropContainer') dragDropContainer: ElementRef;
    loading = false;
    showAlert = false;
    response: any = {};
    alertStatus = '';
    showScreen: boolean;
    rowNumber: number;
    rows = [
      {
        value: 1
      },
      {
        value: 5
      },
      {
        value: 10
      }
    ];
    showSummary: boolean = false;
    amt = null;
    self = {
      windowRef: null
    };
    showDeals: boolean = false;
    columns = ['ID',  'Submitted At', 'Type', 'Name', 'Submitted By', ''];
    attachmentCoumns = ['Date', 'File Name', 'Uploaded By', ''];
    reportDownloadColumns = ['ID',  'File Name', 'Date & Time', 'Report Type', 'Format', 'Status', 'Action'];
    reportDownloadResponse: any;
    transactions = [];
    title: string = null;
    showAttachments: boolean = false;
    editModeForNickName = false;
    documentNumber: string = null;
    comments: string = null;
    screenName: string = null;
    showReportDownload: boolean = false;
    disabledUpload: boolean;

    canSelectDocumentType: boolean = false;
    canUploadDocument: boolean = true;
    documentType: PartyType;
    destroy$ = new ReplaySubject<void>(1);
    fundingAccounts: Array<ClientAccountsInfo> = [];
    fundingAccountsTableColumnTitles = [
      'Account Name', 'Account Number', 'Routing Number', 'Bank Name'
    ];
    countryCode: string;
    issueDate: Date;
    expiryDate: Date;
    countryArray: Country[] = [];

    constructor(
      private windowRef: NbWindowRef,
      private accountService: AccountService,
      private generalService: GeneralService,
      private dialogService: NbDialogService,
      private dateService: NbDateService<Date>,
      private helperService: HelperService
    ) {
        
      this.getCountries();
      var responseData, action;
      this.self.windowRef = windowRef;
      responseData = windowRef.config.context;
      action = windowRef.config.title;

      try {
        this.response = responseData.text;
      } catch(e) {}

      try {
        this.screenName = responseData.screen;
      } catch(e) {}

      if(responseData?.data) {
        this.response = responseData.data
      }

      if(this.response == undefined) {
        this.response = windowRef.config.context;
      }

      this.amt = this.response?.data?.amount;

      if(windowRef.config.title == 'Select Deal')
        this.showDeals = true;
      else
        this.showDeals = false;

      if(windowRef.config.title == 'View Attachments')
        this.showAttachments = true;
      else
        this.showAttachments = false;

      if(this.response == 'Mass Pay')
        this.showScreen = true;
      else
        this.showScreen = false;
      
      try {
        this.title = windowRef.config.title;
        this.documentType = responseData?.documentType;
        const SELECTING_TYPE_ENABLE_REGEX = new RegExp(`${BUCKZY_CONSTANTS.PAGES.PARTY_DETAILS}|${BUCKZY_CONSTANTS.PAGES.BENEFICIAL_OWNER_DETAILS}`);
        if(windowRef.config?.context?.toString?.().match(SELECTING_TYPE_ENABLE_REGEX) || responseData?.data?.toString?.().match(SELECTING_TYPE_ENABLE_REGEX)) {
          this.canSelectDocumentType = true;
          this.disabledUpload = true;
        }
        if (this.title.match(/Add Customer Documents/)) {
          this.documentType = 'B';
          this.canSelectDocumentType = true;
        }
        if (this.title.match(/Add Entity Documents/)) {
          this.documentType = 'I';
          this.canSelectDocumentType = true;
        }
        this.amt = this.response?.data?.amount;
      } catch(e) {}

      try {
        if(action == 'Download CSV Report' || action == 'Download PDF Report') {
          this.showReportDownload = true;
          this.reportDownloadResponse = responseData.content;
        }
        else
          this.showReportDownload = false;

      } catch(e) {}
      this.initializeDocumentTypeCodes();
    }
  
    editNickNameToggle() {
      if(this.editModeForNickName) {
        this.accountService.setAccountNickName(this.response.accountId, this.response.nickName).subscribe(data=>{
        }, err => {console.log(err);});
      }
      this.editModeForNickName = !this.editModeForNickName;
    }

    ngOnInit(): void {
      if(this.windowRef?.config?.title === 'Account Details') {
        this.getFundingAccount(this.windowRef.config.context as ClientAccountsInfo);
      }
    }

    getFundingAccount(account: ClientAccountsInfo): void {
      this.accountService.getFundingAccounts(account?.accountId).pipe(
        takeUntil(this.destroy$)).subscribe(response => {
          this.fundingAccounts = response;
        }, error => {
        });
    }

    viewFundingAccounts(popup: TemplateRef<unknown>): void {
      this.dialogService.open(popup);
    }

    requiresExtraInfo() {
      const documentTypes = ["D002", "D003", "D006", "D008", "D030", "D032",  "D033", "D034"];
      return documentTypes.includes(this.fileType);
    }

    copyToClipboard() {
      // this.loading = true;
      var myInput, myLabel, message = '';
      myInput = document.getElementsByClassName("myInput");
      myLabel = document.getElementsByClassName("myLabel");
      // idText.select();
      for(var i = 0; i < myLabel.length; i++) {
        if(myInput[i].value != '') {
          if(message == '')
            message = myLabel[i].innerText + ": " + myInput[i].value;
          else
            message = message + ", " + myLabel[i].innerText + ": " + myInput[i].value;
        }
        else {
          if(message == '')
            message = myLabel[i].innerText;
          else
            message = message + ", " + myLabel[i].innerText;
        }
      }
      this.copyText(message);
    }

    copyText(val: string){
      let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      
      this.loading = false;
    }

  showData() {
    if(!this.showSummary)
      this.showSummary = true;
  }

  getAmount(amount?: any, comments?: string) {
    if(amount == undefined) {amount = "no amount"}
    this.self.windowRef = this.self.windowRef ? this.self.windowRef : {};
    
    this.self.windowRef.amount = amount;
    this.self.windowRef.comments = comments;
    this.self.windowRef.currency = this.response.data.currency;
    this.self.windowRef.orderId = this.response.data.orderId;
    this.self.windowRef.status = "amount entered";
    this.self.windowRef.windowName = this.screenName;
    this.closeWindow();
  }

  closeWindow() {
    this.self.windowRef.close();
  }

  selectFxDeal(transaction) {
    this.self.windowRef.transaction = transaction;
    this.closeWindow();
  }

  downloadFile(file) {
    this.self.windowRef.documentId = file.transactionDocumentId || file.id;
    this.self.windowRef.documentName = file.fileName;
    this.self.windowRef.windowName = "download_file";
    this.closeWindow();
  }

  uploadFile(event) {
    let fileEvent: File[];
    // if(!this.disabledUpload) {
      if (event.target){
        fileEvent = event.target.files;
      } else {
        fileEvent = event;
      }
      for (let index = 0; index < fileEvent.length; index++) {
        const element = fileEvent[index];
        //if (this.files.length > 0) { this.files = []; } // There can only be one!
        this.fileName.push(element.name);
        this.file = fileEvent[0];
      }

  }

  deleteAttachment(index, screen?: any) {
    this.closeWindow();
  }

  sendFile() {
    let error = false;
    if (this.issueDate > this.expiryDate) {
      this.helperService.showToast('Expiry date cannot be before issue date', null, 5000, 'danger');
      error = true;
    }
    if (this.canSelectDocumentType && !this.fileType) {
      this.helperService.showToast('Document type is required', null, 5000, 'danger');  
      error = true;
    }
    if (!this.file) {
      this.helperService.showToast('Please select a file to upload', null, 5000, 'danger');  
      error = true;
    } else{
      let cleanupFile = false;
      if (this.file.size / 1024 / 1024 > 10) {
        this.helperService.showToast('Maximum allowed file size is 10 MB', null, 5000, 'danger');  
        error = cleanupFile = true;
      }
      const validFileTypes = this.acceptedFileType.split(',').map(type => type.trim().toLowerCase());
      if (!validFileTypes.some(type => this.file.name.toLowerCase().endsWith(type))) {
        this.helperService.showToast('File format not supported. Allowed formats: ' + validFileTypes.join(', '), null, 5000, 'danger');
        error = cleanupFile = true;
      }
      if (cleanupFile) {
        this.file = null;
        this.fileName = [];
      }
    }
    if (this.requiresExtraInfo()) {
      if (!this.fileType){
        this.helperService.showToast('Document number is required', null, 5000, 'danger');  
        error = true;
      }
      if (!this.countryCode) {
        this.helperService.showToast('Issuing country is required', null, 5000, 'danger');  
        error = true;
      }
      if (!this.documentNumber) {
        this.helperService.showToast('Document number is required', null, 5000, 'danger');  
        error = true;
      }
      if (!this.issueDate){
        this.helperService.showToast('Issue date is required', null, 5000, 'danger');  
        error = true;
      }
      if (!this.expiryDate){
        this.helperService.showToast('Expiry date is required', null, 5000, 'danger');  
        error = true;
      } 
    }
    if (error) {
      return;
    }
    this.self.windowRef.file = this.file;
    this.self.windowRef.countryCode = this.countryCode;
    this.self.windowRef.issueDate = this.issueDate;
    this.self.windowRef.expiryDate = this.expiryDate;
    this.self.windowRef.documentNumber = this.documentNumber;
    this.self.windowRef.fileType = this.fileType;
    this.self.windowRef.extraInfo = this.requiresExtraInfo();
    this.self.windowRef.fileName = this.fileName;
    this.self.windowRef.windowName = "upload_file";
    this.closeWindow();
  }

  initializeDocumentTypeCodes() {
    this.fileTypes = this.generalService.getBuckzyCodes('DOCUMENT_TYPE', this.documentType);
  }

  handleFileType(fileType: string) {
    this.self.windowRef.fileType = fileType;
    if(this.fileType) {
      this.disabledUpload = false;
    }

    this.fileTypes.forEach(documents => {
      for (let document of documents) {
        if (fileType.includes(document.code)) {
          this.self.windowRef.documentType = JSON.parse(JSON.stringify(document));
        }
      }

    })
  }

  offsetIssueDateTimezone(event: Date) {
    if (event) {
      const offset = event.getTimezoneOffset();
      this.issueDate = new Date(event.getTime() + offset * 60 * 1000);
    }
  }

  offsetExpiryDateTimezone(event: Date) {
    if (event) {
      const offset = event.getTimezoneOffset();
      this.expiryDate = new Date(event.getTime() + offset * 60 * 1000);
    }
  }
   
  getCountries() {
    this.generalService.getCountries().subscribe({
      next: (countries) => {
        this.countryArray = countries;
      },
    });
  }
}

